<template>
  <el-dialog title="产品" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
    <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="100px">
      <el-form-item label="产品" prop="id">
        <el-select v-model="form.id" filterable clearable placeholder="请选择">
          <el-option v-for="item in productOptions" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import sysGoodsApi from '@/api/goods/sysGoods'
function initFormBean() {
  const formBean = {
    id: null,
  }
  return formBean
}

export default {
  data() {
    return {
      form: initFormBean(),
      formVisible: false,
      formRules: {
        id: [{ required: true, message: '请选择产品', trigger: 'change' }],
      },
    }
  },
  created() {

  },
  methods: {
    getProductOptions() {
      sysGoodsApi.productOptions({areaCodes: 'CPSC,XDB,ZSZH'}).then((res) => {
        let { list } = res.data;
        this.productOptions = list;
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      })
    },
    handleShow() {
      this.form = initFormBean()
      this.getProductOptions()

    },
    doCreate() {
      this.$refs["dataForm"].validate((valid) => {
        if (valid) {
          let { id } = this.form;
          let find = this.productOptions.find(itt => itt.id === id)
          this.$emit('created', find, 1)
          this.formVisible = false
        }
      });
    },

  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-select {
  width: 100%;
}

.input-box {
  display: flex;
  align-items: center;
  margin-bottom: 18px;
  i {
    cursor: pointer;
  }
}

.input-box:last-child {
  margin-bottom: 0;
}

::v-deep .el-icon-plus,
.el-icon-minus {
  margin-left: 4px;
  color: #60b7dc;
}
</style>
